/**
 * «Annulla spedizione», and the confirmation in front of it.
 *
 * Cancelling cannot be taken back from here: the labels already on the boxes
 * stop being valid, and somebody has to cover or remove them. The dialog says
 * so before anything leaves, and starts with the focus on the way back, as the
 * receiving bench's dialogs do. One component, used by the «Spedite» card and
 * by «Da sistemare», so the copy lives in one place.
 */

import { useState } from 'react';
import type { CarrierName } from '@errebi/domain';

import { Modale } from '../../components/modal';

export interface PropsAnnullaSpedizione {
  readonly ordine: string;
  readonly corriere: CarrierName;
  readonly colli: number;
  readonly inCorso: boolean;
  readonly fai: (percorso: string, corpo?: unknown) => () => void;
}

export function AnnullaSpedizione({
  ordine,
  corriere,
  colli,
  inCorso,
  fai,
}: PropsAnnullaSpedizione) {
  const [chiede, setChiede] = useState(false);
  const quanti = colli === 1 ? '1 collo' : `${colli} colli`;

  return (
    <>
      <div className="mods" style={{ marginTop: 8 }}>
        <button className="mod mod--no" disabled={inCorso} onClick={() => setChiede(true)}>
          Annulla spedizione
        </button>
      </div>

      {chiede && (
        <Modale
          etichetta={`Annullare la spedizione ${corriere} di ${ordine}?`}
          ruolo="alertdialog"
          onChiudi={() => setChiede(false)}
        >
          <p className="gesto__k">
            Annullare la spedizione {corriere} di {quanti}? Le etichette già stampate sulle scatole
            vanno coperte o tolte.
          </p>
          <div className="mods" style={{ marginTop: 12 }}>
            <button className="mod" autoFocus onClick={() => setChiede(false)}>
              Torna indietro
            </button>
            <button
              className="mod mod--no"
              disabled={inCorso}
              onClick={() => {
                setChiede(false);
                fai(`/fine-linea/${ordine}/annulla`)();
              }}
            >
              Annulla spedizione
            </button>
          </div>
        </Modale>
      )}
    </>
  );
}
